import makeStyles from '@mui/styles/makeStyles';
const drawerWidth = 240;
export const style = makeStyles((theme) => ({
    input: {
        marginTop: '20px',
        marginBottom: '10px',
    },
}));
